import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import StateContext from "../../context/StateContext";

const PrivateRoute = ({ component: Component, ...rest }) => {
	const { customer, loading } = useContext(StateContext);

	if (loading) {
		return null;
	}

	return (
		// Show the component only when the user is logged in
		// Otherwise, redirect the user to /login page
		<Route {...rest} render={(props) => (customer ? <Component {...props} /> : <Redirect to="/login" />)} />
	);
};

export default PrivateRoute;
